import { Icon, Tooltip } from "../../../components";

export const editarQuantidadeItemDevolucao = (
  params,
  event,
  setListaItensGrid,
  setListaItensSelecionados,
) => {
  if (event.key === "Enter") {
    const quantidade =
      parseFloat(event.target.value) > params.value
        ? params.value
        : parseFloat(event.target.value);
    const desconto = (params.row.desconto / params.row.quantidade) * quantidade;
    const acrescimo =
      (params.row.acrescimo / params.row.quantidade) * quantidade;
    const saldoExportar =
      parseFloat(event.target.value) > params.value
        ? params.value
        : parseFloat(event.target.value);
    const formatarProdutosKit = (item) =>
      item.produtosKit?.map((kit) => {
        const proporcao = parseInt(kit.quantidade / item.quantidade);
        return {
          ...kit,
          quantidade: proporcao * quantidade,
        };
      });
    const atualizarItem = (item) => {
      const produtosKit = formatarProdutosKit(item);
      return {
        ...item,
        quantidade,
        subtotal: (params.row.valor || params.row.precoCompra) * quantidade,
        desconto,
        acrescimo,
        saldoExportar,
        produtosKit,
      };
    };
    setListaItensGrid((prevState) =>
      prevState.map((obj) =>
        obj.id == params.row.id ? atualizarItem(obj) : obj,
      ),
    );
    setListaItensSelecionados((prevState) =>
      prevState.map((obj) =>
        obj.id == params.row.id ? atualizarItem(obj) : obj,
      ),
    );
  }
};

export function obterIconeStatus(status) {
  switch (status) {
    case "PENDENTE":
      return (
        <Tooltip title="Pendente" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#EA9D2B", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "ENVIADA":
      return (
        <Tooltip title="Enviada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#4FBB53", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "CONTINGENCIA":
      return (
        <Tooltip title="Em Contigência" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#BFBFBF", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "CANCELADA":
      return (
        <Tooltip title="Cancelada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#DC3545", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "INUTILIZADA":
      return (
        <Tooltip title="Inutilizada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#e012a6", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "DENEGADA":
      return (
        <Tooltip title="Denegada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#70309F", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "EM PROCESSAMENTO":
      return (
        <Tooltip title="Em Processamento" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#A0522D", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "FATURADA":
      return (
        <Tooltip title="Faturada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#004780", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
  }
}
